import React from 'react'
import { Link } from 'react-router-dom'
import lot from '../Assets/lottery_banner.png'
import aviator from '../Assets/aviatoricon.png'
import mines from '../Assets/minesicon.png'
const Games = () => {

  return (
    <div className='grid grid-cols-3 text-white font-bold justify-between gap-4 w-full h-auto p-3 '>
        <Link className='bg-white rounded-lg shadow-md' to='aviator' style={{ '--i':'orange' }} >
        <div  className='h-[90px] flex flex-col justify-center items-center rounded-lg '>
            <div className=''>
              <img style={{ height:'90px' }} src={aviator} alt='img'/>
            </div>
        </div>
        <p className='font-semibold text-black mt-2 px-2'>Aviator</p>
        </Link>
        <Link to='/' style={{ '--i':'orange' }} >
        <div  className='h-[90px] flex flex-col justify-center items-center  bg-orange-500 p-4 rounded-lg shadow-md shadow-orange-700'>
            <div className=''>
              <img width={75} height={75} src={lot} alt='img'/>
            </div>
        </div>
        <p className='font-semibold text-black mt-2 text-center'>Lottery</p>
        </Link>
        <Link className='bg-white rounded-lg shadow-md' to='mines' style={{ '--i':'orange' }} >
        <div  className='h-[90px] flex flex-col justify-center items-center rounded-lg '>
            <img style={{ height:'90px' }} src={mines} alt='img'/>
        </div>
        <p className='font-semibold px-2 text-black mt-2'>Mines</p>
        </Link>
    </div>
  )
}

export default Games